import React from 'react';
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/lib/styles.css';
import ImageZoom from "./ImageZoom";

const Slider = ({images}) => {
    const options = {
        items: 1,
        margin: 5,
        nav: true,
        loop: true,
        dots: true,
        navText: [],
        touchDrag: false,
        mouseDrag: false,
        animateOut: 'fadeOut',
        autoplay: true,
        autoplayTimeout: 4500,
        autoplayHoverPause: true,
    };

    const item = {
        items: images.map(image => <ImageZoom key={image} image={image} />)
    };

    return (
        <OwlCarousel
            options={options}
            touch-action="pan-y"
            className="js-decision_sliders decision_sliders owl-carousel owl-theme"
        >{item.items}
        </OwlCarousel>
    );
};

export default Slider;